import React, { useEffect, useState } from "react";
import { areas } from "../../helpers/areas";
import { useSelector, useDispatch } from "react-redux";
import {
  Pageview,
  AddCircle,
  Edit,
  Search,
  Delete,
  Warning,
} from "@material-ui/icons";

import {
  TableContainer,
  Paper,
  TableHead,
  TableBody,
  Table,
  TableRow,
  TableCell,
  Grid,
  Button,
  Avatar,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import {
  seleccionAfiliado,
  desSeleccionarAfiliado,
  traerAfiliadoXId,
} from "../../actions/afiliado";
import { ModalFamiliarAlta } from "./ModalFamiliarAlta";
import {
  grupoFamiliarSetTab,
  limpiarSeleccionFamiliar,
  seleccionFamiliarPreinscripto,
  seleccionFamiliarPreinscriptoStage,
} from "../../actions/familiarSeleccionado";
import {
  limpiarListaDocumentacionAfiliado,
  fetchDocumentacionAfiliacion,
  fetchDocumentacionStageFamiliarAfiliacion,
} from "../../actions/documentaciones/documentacion";
import {
  observacionesLimpiar,
  fetchObservaciones,
} from "../../actions/observaciones";
import {
  certificadosLimpiar,
  fetchCertificados,
  fetchCertificadosStage,
} from "../../actions/certificados";
import { grupoFamiliarDeleteFamiliar } from "../../actions/grupoFamiliarPreinscripto";
import {
  empresasAfiliadoLimpiar,
  fetchEmpresasAfiliado,
} from "../../actions/empresasAfiliado";
import { aportesLimpiar, fetchAportes } from "../../actions/aportes";
import {
  traerMovimientos,
  movimientosLimpiar,
} from "../../actions/movimientos/movimientos";
import { PARENTESCOS, TIPO_DOCUMENTO } from "../../utils/constants";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const style = {
  paper: {
    marginTop: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  button: {
    width: 64,
    height: 64,
    padding: 0,
  },
  iconButton: {
    width: 32,
    height: 32,
    padding: 0,
    marginTop: 0,
    marginBottom: 0,
  },
  avatar: {
    margin: 5,
    backgroundColor: "#1976d2",
    width: 60,
    height: 60,
  },
  iconMed: {
    fontSize: 18,
    display: "flex",
    alignItems: "center",
  },
  avatarWarnVisible: {
    margin: 2,
    backgroundColor: "red",
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
  },
  avatarWarnNotVisible: {
    display: "none",
  },
};

export const GrillaGrupoFamiliar = ({
  setTab,
  idGrupo,
  idForm,
  fromBandejaFamiliar,
  esModificacion,
}) => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const { items, cargada: listaFamiliaresCargada } = useSelector((state) =>
    idGrupo !== "idGrupoFamiliarPreinscripto"
      ? state.grupofamiliar
      : state.grupofamiliarPreinscripto
  );
  const { items: localidades, cargada: localidadesCargada } = useSelector(
    (state) => state.localidades
  );
  const { items: provincias, cargada: provinciasCargada } = useSelector(
    (state) => state.provincias
  );
  const { seleccionado, afiliado: afiselec } = useSelector(
    (state) => state.afiliacion
  );
  const { consultaAfiliado, seleccionadoConsulta } = useSelector(
    (state) => state.afiliacion
  );
  const { familiarStagePreafiliadoSeleccionado } = useSelector(
    (state) => state.familiarSeleccionado
  );
  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);

  const handleAfiSelec = (afiliado) => {
    if (!!afiliado) {
      setTab(0);
      dispatch(seleccionAfiliado(afiliado));
      if (!isNaN(afiliado?.id_afiliado)) {
        dispatch(fetchDocumentacionAfiliacion(afiliado?.id_afiliado));
        dispatch(fetchEmpresasAfiliado(afiliado?.id_afiliado));
        dispatch(fetchObservaciones(afiliado?.id_afiliado));
        dispatch(fetchCertificados(afiliado?.id_afiliado));
        dispatch(fetchAportes(afiliado?.cuil));
        dispatch(traerAfiliadoXId(afiliado?.id_afiliado));
        dispatch(traerMovimientos(afiliado?.id_afiliado));
      }
    } else {
      limpiarComponente();
    }
  };

  const handleAfiConSelec = (afiliado) => {
    console.log("Es aca 3");
    if (!!afiliado) {
      setTab(0);
      dispatch(seleccionAfiliado(afiliado, "idConsulta"));
      if (!isNaN(afiliado?.id_afiliado)) {
        dispatch(fetchDocumentacionAfiliacion(afiliado?.id_afiliado));
        dispatch(fetchEmpresasAfiliado(afiliado?.id_afiliado));
        dispatch(fetchObservaciones(afiliado?.id_afiliado));
        dispatch(fetchCertificados(afiliado?.id_afiliado));
        dispatch(traerMovimientos(afiliado?.id_afiliado));
        dispatch(fetchAportes(afiliado?.cuil));
      }
    } else {
      limpiarComponente();
    }
  };

  const limpiarComponente = () => {
    dispatch(desSeleccionarAfiliado());
    dispatch(limpiarListaDocumentacionAfiliado());
    dispatch(empresasAfiliadoLimpiar());
    dispatch(observacionesLimpiar());
    dispatch(certificadosLimpiar());
    dispatch(aportesLimpiar());
    dispatch(movimientosLimpiar());
  };

  const handleAddDocFamiliar = (fami) => {
    dispatch(seleccionFamiliarPreinscripto(fami.id_afiliado));
    dispatch(fetchCertificadosStage(fami.id_afiliado));
    dispatch(grupoFamiliarSetTab(0));
    handleClickOpen();
  };

  const deleteFamiliar = (fami) => {
    dispatch(grupoFamiliarDeleteFamiliar(fami.id_afiliado));
  };

  const handleClickOpen = () => {
    dispatch(grupoFamiliarSetTab(0));
    setOpen(true);
    dispatch(limpiarSeleccionFamiliar());
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(limpiarListaDocumentacionAfiliado());
  };

  const handleSelectPreafiliadoStage = (afiliado) => {
    dispatch(grupoFamiliarSetTab(0));
    dispatch(fetchCertificadosStage(afiliado.id_afiliado));
    dispatch(seleccionFamiliarPreinscriptoStage(afiliado.id_afiliado));
    dispatch(fetchDocumentacionStageFamiliarAfiliacion(afiliado.id_afiliado));
  };

  useEffect(() => {
    if (Object.keys(familiarStagePreafiliadoSeleccionado).length > 0 && !open) {
      setOpen(true);
    }
    // eslint-disable-next-line
  }, [familiarStagePreafiliadoSeleccionado]);

  const afiliadosOrdenadosPorParentesco = [...items].sort((a, b) => {
    if (a.id_parentesco < b.id_parentesco) {
      return -1;
    } else if (a.id_parentesco > b.id_parentesco) {
      return 1;
    } else {
      if (a.carnet < b.carnet) {
        return -1;
      } else if (a.carnet > b.carnet) {
        return 1;
      } else {
        return 0;
      }
    }
  });

  return (
    <>
      <ModalFamiliarAlta
        open={open}
        handleClose={handleClose}
        idGrupo={idGrupo}
      />
      <Button
        disabled={
          idForm === "formConsulta" || esModificacion || fromBandejaFamiliar ? true : false
        }
        variant="contained"
        color="secondary"
        style={{ marginTop: 15, marginBottom: 10 }}
        onClick={handleClickOpen}
        startIcon={<AddCircle />}
      >
        Incorporar Familiar
      </Button>
      {listaFamiliaresCargada && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left"></TableCell>
                <TableCell align="left">Nro Afiliado</TableCell>
                <TableCell align="left">Apellido y Nombre</TableCell>
                <TableCell align="left">Nro Documento</TableCell>
                <TableCell align="left">Parentesco</TableCell>
                <TableCell align="left">Fecha Nacimiento</TableCell>
                <TableCell align="left">Localidad</TableCell>
                <TableCell align="left">Provincia</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {afiliadosOrdenadosPorParentesco.map((afiliado) => (
                <TableRow key={afiliado.id_afiliado}>
                  <TableCell align="left">
                    {idForm === "formPreafiliadosStage" &&
                      afiliado.id_parentesco !== 0 && (
                        <>
                          <IconButton
                            style={{ padding: 0, margin: 0 }}
                            onClick={(e) =>
                              handleSelectPreafiliadoStage(afiliado)
                            }
                            color="primary"
                            aria-label="seleccionar"
                          >
                            <Pageview style={style.iconButton} />
                          </IconButton>
                        </>
                      )}
                    {idGrupo
                      ? afiliado.id_parentesco !== 0 &&
                        (idAreaUsuario === areas.Nacional ? (
                          <IconButton
                            style={{ padding: 0, margin: 0 }}
                            onClick={(e) => handleAddDocFamiliar(afiliado)}
                            color="primary"
                            aria-label="seleccionar"
                          >
                            <Search style={style.iconButton} />
                          </IconButton>
                        ) : (
                          <IconButton
                            style={{ padding: 0, margin: 0 }}
                            onClick={(e) => handleAddDocFamiliar(afiliado)}
                            color="primary"
                            aria-label="seleccionar"
                          >
                            <Edit style={style.iconButton} />
                          </IconButton>
                        ))
                      : seleccionado &&
                        idForm !== "formConsulta" &&
                        afiselec.id_afiliado !== afiliado.id_afiliado && (
                          <IconButton
                            style={{ padding: 0, margin: 0 }}
                            onClick={(e) => handleAfiSelec(afiliado)}
                            color="primary"
                            aria-label="seleccionar"
                          >
                            <Pageview style={style.iconButton} />
                          </IconButton>
                        )}
                    {idForm === "formConsulta" &&
                      seleccionadoConsulta &&
                      consultaAfiliado.id_afiliado !== afiliado.id_afiliado && (
                        <IconButton
                          style={{ padding: 0, margin: 0 }}
                          onClick={(e) => handleAfiConSelec(afiliado)}
                          color="primary"
                          aria-label="seleccionar"
                        >
                          <Pageview style={style.iconButton} />
                        </IconButton>
                      )}
                  </TableCell>
                  <TableCell align="left">
                    <Grid container spacing={1}>
                      <div style={{ paddingTop: "5px" }}>{afiliado.carnet}</div>
                    </Grid>
                  </TableCell>
                  <TableCell align="left">
                    <Grid container spacing={1}>
                      <Avatar
                        style={
                          afiliado.fecha_baja
                            ? style.avatarWarnVisible
                            : style.avatarWarnNotVisible
                        }
                      >
                        <Tooltip
                          title="Afiliado dado de baja"
                          placement="right-start"
                        >
                          <Warning style={style.iconMed} />
                        </Tooltip>
                      </Avatar>
                      <div style={{ paddingTop: "5px" }}>
                        {afiliado.apellido_y_nombre.toUpperCase()}
                      </div>
                    </Grid>
                  </TableCell>
                  <TableCell align="left">
                    {afiliado.id_tipo_documento === TIPO_DOCUMENTO.DNI && "DNI"}
                    {afiliado.id_tipo_documento ===
                      TIPO_DOCUMENTO.CEDULA_IDENTIDAD && "CI"}
                    {afiliado.id_tipo_documento ===
                      TIPO_DOCUMENTO.LIBRETA_ENROLAMIENTO && "LE"}
                    {afiliado.id_tipo_documento ===
                      TIPO_DOCUMENTO.LIBRETA_CIVICA && "LC"}
                    {afiliado.id_tipo_documento === TIPO_DOCUMENTO.PASAPORTE &&
                      "PAS"}
                    {afiliado.id_tipo_documento === TIPO_DOCUMENTO.NI && "NI"}
                    {afiliado.id_tipo_documento === TIPO_DOCUMENTO.RN && "RN"}
                    {`  ${afiliado.nro_doc}`}
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    {afiliado.id_parentesco === PARENTESCOS.TITULAR &&
                      "TITULAR"}
                    {afiliado.id_parentesco === PARENTESCOS.CONYUGE &&
                      "CONYUGE"}
                    {afiliado.id_parentesco === PARENTESCOS.CONCUBINA_O &&
                      "CONCUBINA/O"}
                    {afiliado.id_parentesco === PARENTESCOS.HIJO_MENOR &&
                      "HIJO MENOR"}
                    {afiliado.id_parentesco === PARENTESCOS.HIJO_ESTUDIANTE &&
                      "HIJO ESTUDIANTE"}
                    {afiliado.id_parentesco === PARENTESCOS.FAMILIAR_A_CARGO &&
                      "FLIAR.A CARGO"}
                    {afiliado.id_parentesco ===
                      PARENTESCOS.HIJO_DISCAPACITADO && "HIJO DISCAPACITADO"}
                    {afiliado.id_parentesco ===
                      PARENTESCOS.MENOR_BAJO_GUARDA_O_TUTELA &&
                      "MENOR BAJO GUARDA"}
                    {afiliado.id_parentesco === PARENTESCOS.HIJO_CONYUGE &&
                      "HIJO CONYUGE"}
                    {afiliado.id_parentesco ===
                      PARENTESCOS.HIJO_CONYUGE_ESTUDIANTE &&
                      "HIJO CONYUGE ESTUDIANTE"}
                  </TableCell>
                  <TableCell align="left">
                    {new Date(afiliado.fecha_nacimiento).toLocaleString(
                      "es",
                      optionsfecha
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {localidadesCargada &&
                      localidades.find(
                        (loc) =>
                          loc.id_localidad ===
                          afiliado.domiciliosAfiliados?.id_localidad
                      )?.descripcion_localidad}
                  </TableCell>
                  <TableCell align="left">
                    {provinciasCargada &&
                      provincias.find(
                        (prov) =>
                          prov.id_provincia ===
                          afiliado.domiciliosAfiliados?.id_provincia
                      )?.descripcion_provincia}
                  </TableCell>
                  <TableCell>
                    {idGrupo &&
                      afiliado.id_parentesco !== 0 &&
                      idAreaUsuario === areas.Seccional && (
                        <IconButton
                          style={{ padding: 0, margin: 0 }}
                          onClick={(e) => deleteFamiliar(afiliado)}
                          color="primary"
                          aria-label="seleccionar"
                        >
                          <Delete />
                        </IconButton>
                      )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};
